import { Link, LinkProps } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { linkUnderlineStyles } from '../../../PlanCard.styles';

export const SmallerLink = styled(Link)<Partial<LinkProps>>`
    font-size: ${getPurpurTypography('scale75')};
    text-decoration-line: underline;
    text-align: right;
    a {
        color: ${({ negative }) => (negative ? getPurpurColor('functionalWhite') : getPurpurColor('textDefault'))};
        ${({ negative }) => linkUnderlineStyles(negative)};
    }
`;
